import { render, staticRenderFns } from "./configuration-automation-personnel-algorithms-definition-modal.vue?vue&type=template&id=a32850a8&scoped=true&"
import script from "./configuration-automation-personnel-algorithms-definition-modal.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-personnel-algorithms-definition-modal.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-personnel-algorithms-definition-modal.scss?vue&type=style&index=0&id=a32850a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32850a8",
  null
  
)

export default component.exports